import React from "react"
import Layout from "../layout/layout"
import Social from "../components/Social"
import styled from "styled-components"
import ModalBox from "../components/ModalBox"
import { Link } from "gatsby"
import PostPreview from "../components/PostPreview"
import usePosts from "../hooks/usePosts"
import Section from "../components/Section"
import global from "../css/globalVariables"
import config from "../../data/SiteConfig"
import SEO from "../components/SEO"
import { Helmet } from "react-helmet"
import WorkBox from "../components/WorkBox"
import Code from "../assets/icons/code.svg"
import Design from "../assets/icons/design.svg"
import Game from "../assets/icons/game.svg"

const CenterSection = styled(Section)`
	text-align: center;
`
const Hero = styled.section`
	display: flex;
	justify-content: space-between;
`

const Intro = styled.div`
	@media screen and (${global.mediaDesktop}) {
		max-width: 60%;
	}
`
const ContactLink = styled(Link)`
	&& {
		color: ${(props) => props.theme.bg};
		text-decoration: underline;
	}
`

const Work = styled.div`
	display: flex;
	justify-content: space-evenly;
	flex-direction: column;
	@media screen and (${global.mediaDesktop}) {
		flex-direction: row;
	}
`

const TechList = styled.ul`
	list-style-type: none;
	padding: 0;
	& li {
		margin-bottom: 15px;
	}
`

const TechListLink = styled.a`
	display: flex;
	align-items: center;
`

const IndexPage = () => {
	const posts = usePosts({ limit: 5 })

	return (
		<Layout>
			<Helmet>
				<title>{`${config.siteTitle} –  Basel Web Developer`}</title>
				<SEO
					description="Its me: Gianluca Frongia. I'm a front end developer creating and designing website for people
						with great ideas."
				/>
			</Helmet>
			<Hero>
				<Intro>
					<h1>Its me: Gianluca Frongia</h1>
					<p>
						I'm a front end developer creating and designing website for people
						with great ideas. Currently open for freelancing jobs located in
						Basel.
					</p>
					<ModalBox>
						Are you a design/graphic student located in Basel ? Then I would
						love to create your first portfolio website! ( free ofc ;) ) You can
						contact me <ContactLink to="./contact">here</ContactLink>
					</ModalBox>
				</Intro>
				<Social />
			</Hero>
			<CenterSection>
				<h2>What I Do</h2>
				<Work>
					<WorkBox title="Programming" icon={<Code />} />
					<WorkBox title="Web Design" icon={<Design />} />
					<WorkBox title="Game Dev" icon={<Game />} info="coming soon" />
				</Work>
			</CenterSection>
			<Section>
				<p>
					In every area of my work activities I try to find new ways to solve
					problems. For this reason I use bleeding edge technologies to solve
					problems. This way I am constantly reinventing myself and shortening
					my sleeping nights.
				</p>
				<p>I'm curenntly learning and using these technologies:</p>
				<TechList>
					<li>
						<TechListLink
							alt="Gatsby JS Website"
							href="https://www.gatsbyjs.org/"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 106 28"
								focusable="false"
								height="50px"
							>
								<title>Gatsby</title>
								<path
									fill="#fff"
									d="M62.9 12h2.8v10h-2.8v-1.3c-1 1.5-2.3 1.6-3.1 1.6-3.1 0-5.1-2.4-5.1-5.3 0-3 2-5.3 4.9-5.3.8 0 2.3.1 3.2 1.6V12zm-5.2 5c0 1.6 1.1 2.8 2.8 2.8 1.6 0 2.8-1.2 2.8-2.8 0-1.6-1.1-2.8-2.8-2.8-1.6 0-2.8 1.2-2.8 2.8zm13.5-2.6V22h-2.8v-7.6h-1.1V12h1.1V8.6h2.8V12h1.9v2.4h-1.9zm8.5 0c-.7-.6-1.3-.7-1.6-.7-.7 0-1.1.3-1.1.8 0 .3.1.6.9.9l.7.2c.8.3 2 .6 2.5 1.4.3.4.5 1 .5 1.7 0 .9-.3 1.8-1.1 2.5s-1.8 1.1-3 1.1c-2.1 0-3.2-1-3.9-1.7l1.5-1.7c.6.6 1.4 1.2 2.2 1.2.8 0 1.4-.4 1.4-1.1 0-.6-.5-.9-.9-1l-.6-.2c-.7-.3-1.5-.6-2.1-1.2-.5-.5-.8-1.1-.8-1.9 0-1 .5-1.8 1-2.3.8-.6 1.8-.7 2.6-.7.7 0 1.9.1 3.2 1.1l-1.4 1.6zm6.1-1.1c1-1.4 2.4-1.6 3.2-1.6 2.9 0 4.9 2.3 4.9 5.3s-2 5.3-5 5.3c-.6 0-2.1-.1-3.2-1.6V22H83V5.2h2.8v8.1zm-.3 3.7c0 1.6 1.1 2.8 2.8 2.8 1.6 0 2.8-1.2 2.8-2.8 0-1.6-1.1-2.8-2.8-2.8-1.7 0-2.8 1.2-2.8 2.8zm13 3.5L93.7 12H97l3.1 5.7 2.8-5.7h3.2l-8 15.3h-3.2l3.6-6.8zM54 13.7h-7v2.8h3.7c-.6 1.9-2 3.2-4.6 3.2-2.9 0-5-2.4-5-5.3S43.1 9 46 9c1.6 0 3.2.8 4.2 2.1l2.3-1.5C51 7.5 48.6 6.3 46 6.3c-4.4 0-8 3.6-8 8.1s3.4 8.1 8 8.1 8-3.6 8-8.1c.1-.3 0-.5 0-.7z"
								></path>
								<path
									d="M25 14h-7v2h4.8c-.7 3-2.9 5.5-5.8 6.5L5.5 11c1.2-3.5 4.6-6 8.5-6 3 0 5.7 1.5 7.4 3.8l1.5-1.3C20.9 4.8 17.7 3 14 3 8.8 3 4.4 6.7 3.3 11.6l13.2 13.2C21.3 23.6 25 19.2 25 14zm-22 .1c0 2.8 1.1 5.5 3.2 7.6 2.1 2.1 4.9 3.2 7.6 3.2L3 14.1z"
									fill="#ffffff"
								></path>
								<path
									d="M14 0C6.3 0 0 6.3 0 14s6.3 14 14 14 14-6.3 14-14S21.7 0 14 0zM6.2 21.8C4.1 19.7 3 16.9 3 14.2L13.9 25c-2.8-.1-5.6-1.1-7.7-3.2zm10.2 2.9L3.3 11.6C4.4 6.7 8.8 3 14 3c3.7 0 6.9 1.8 8.9 4.5l-1.5 1.3C19.7 6.5 17 5 14 5c-3.9 0-7.2 2.5-8.5 6L17 22.5c2.9-1 5.1-3.5 5.8-6.5H18v-2h7c0 5.2-3.7 9.6-8.6 10.7z"
									fill="#663399"
								></path>
							</svg>
						</TechListLink>
					</li>
					<li>
						<TechListLink
							alt="Tailwindcss Website"
							href="https://tailwindcss.com/"
						>
							{" "}
							<svg
								class="h-12 w-auto hidden md:block"
								viewBox="0 0 273 64"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								height="50px"
							>
								<title>Tailwind CSS</title>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M32 16C24.8 16 20.3 19.6 18.5 26.8C21.2 23.2 24.35 21.85 27.95 22.75C30.004 23.2635 31.4721 24.7536 33.0971 26.4031C35.7443 29.0901 38.8081 32.2 45.5 32.2C52.7 32.2 57.2 28.6 59 21.4C56.3 25 53.15 26.35 49.55 25.45C47.496 24.9365 46.0279 23.4464 44.4029 21.7969C41.7557 19.1099 38.6919 16 32 16ZM18.5 32.2C11.3 32.2 6.8 35.8 5 43C7.7 39.4 10.85 38.05 14.45 38.95C16.504 39.4635 17.9721 40.9536 19.5971 42.6031C22.2443 45.2901 25.3081 48.4 32 48.4C39.2 48.4 43.7 44.8 45.5 37.6C42.8 41.2 39.65 42.55 36.05 41.65C33.996 41.1365 32.5279 39.6464 30.9029 37.9969C28.2557 35.3099 25.1919 32.2 18.5 32.2Z"
									fill="url(#paint0_linear)"
								></path>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M85.996 29.652H81.284V38.772C81.284 41.204 82.88 41.166 85.996 41.014V44.7C79.688 45.46 77.18 43.712 77.18 38.772V29.652H73.684V25.7H77.18V20.596L81.284 19.38V25.7H85.996V29.652ZM103.958 25.7H108.062V44.7H103.958V41.964C102.514 43.978 100.272 45.194 97.308 45.194C92.14 45.194 87.846 40.824 87.846 35.2C87.846 29.538 92.14 25.206 97.308 25.206C100.272 25.206 102.514 26.422 103.958 28.398V25.7ZM97.954 41.28C101.374 41.28 103.958 38.734 103.958 35.2C103.958 31.666 101.374 29.12 97.954 29.12C94.534 29.12 91.95 31.666 91.95 35.2C91.95 38.734 94.534 41.28 97.954 41.28ZM114.902 22.85C113.458 22.85 112.28 21.634 112.28 20.228C112.28 18.784 113.458 17.606 114.902 17.606C116.346 17.606 117.524 18.784 117.524 20.228C117.524 21.634 116.346 22.85 114.902 22.85ZM112.85 44.7V25.7H116.954V44.7H112.85ZM121.704 44.7V16.96H125.808V44.7H121.704ZM152.446 25.7H156.778L150.812 44.7H146.784L142.832 31.894L138.842 44.7H134.814L128.848 25.7H133.18L136.866 38.81L140.856 25.7H144.77L148.722 38.81L152.446 25.7ZM161.87 22.85C160.426 22.85 159.248 21.634 159.248 20.228C159.248 18.784 160.426 17.606 161.87 17.606C163.314 17.606 164.492 18.784 164.492 20.228C164.492 21.634 163.314 22.85 161.87 22.85ZM159.818 44.7V25.7H163.922V44.7H159.818ZM178.666 25.206C182.922 25.206 185.962 28.094 185.962 33.034V44.7H181.858V33.452C181.858 30.564 180.186 29.044 177.602 29.044C174.904 29.044 172.776 30.64 172.776 34.516V44.7H168.672V25.7H172.776V28.132C174.03 26.156 176.082 25.206 178.666 25.206ZM205.418 18.1H209.522V44.7H205.418V41.964C203.974 43.978 201.732 45.194 198.768 45.194C193.6 45.194 189.306 40.824 189.306 35.2C189.306 29.538 193.6 25.206 198.768 25.206C201.732 25.206 203.974 26.422 205.418 28.398V18.1ZM199.414 41.28C202.834 41.28 205.418 38.734 205.418 35.2C205.418 31.666 202.834 29.12 199.414 29.12C195.994 29.12 193.41 31.666 193.41 35.2C193.41 38.734 195.994 41.28 199.414 41.28ZM223.278 45.194C217.54 45.194 213.246 40.824 213.246 35.2C213.246 29.538 217.54 25.206 223.278 25.206C227.002 25.206 230.232 27.144 231.752 30.108L228.218 32.16C227.382 30.374 225.52 29.234 223.24 29.234C219.896 29.234 217.35 31.78 217.35 35.2C217.35 38.62 219.896 41.166 223.24 41.166C225.52 41.166 227.382 39.988 228.294 38.24L231.828 40.254C230.232 43.256 227.002 45.194 223.278 45.194ZM238.592 30.944C238.592 34.402 248.814 32.312 248.814 39.342C248.814 43.142 245.508 45.194 241.404 45.194C237.604 45.194 234.868 43.484 233.652 40.748L237.186 38.696C237.794 40.406 239.314 41.432 241.404 41.432C243.228 41.432 244.634 40.824 244.634 39.304C244.634 35.922 234.412 37.822 234.412 31.02C234.412 27.448 237.49 25.206 241.366 25.206C244.482 25.206 247.066 26.65 248.396 29.158L244.938 31.096C244.254 29.614 242.924 28.93 241.366 28.93C239.884 28.93 238.592 29.576 238.592 30.944ZM256.11 30.944C256.11 34.402 266.332 32.312 266.332 39.342C266.332 43.142 263.026 45.194 258.922 45.194C255.122 45.194 252.386 43.484 251.17 40.748L254.704 38.696C255.312 40.406 256.832 41.432 258.922 41.432C260.746 41.432 262.152 40.824 262.152 39.304C262.152 35.922 251.93 37.822 251.93 31.02C251.93 27.448 255.008 25.206 258.884 25.206C262 25.206 264.584 26.65 265.914 29.158L262.456 31.096C261.772 29.614 260.442 28.93 258.884 28.93C257.402 28.93 256.11 29.576 256.11 30.944Z"
									fill="#fff"
								></path>
								<defs>
									<linearGradient
										id="paint0_linear"
										x1="3.5"
										y1="16"
										x2="59"
										y2="48"
										gradientUnits="userSpaceOnUse"
									>
										<stop stop-color="#2298BD"></stop>
										<stop offset="1" stop-color="#0ED7B5"></stop>
									</linearGradient>
								</defs>
							</svg>
						</TechListLink>
					</li>
				</TechList>
			</Section>
			<Section>
				<h2>My lastest Posts</h2>
				<article>
					{posts.map((post) => (
						<PostPreview post={post} key={post.title} />
					))}

					<Link to="/articles">View all posts</Link>
				</article>{" "}
			</Section>

			<Section>
				<h2>Why are you doing free work ?</h2>
				<p>
					If you are good at something, never do it for free. ~The Joker <br />
					The Joker may be partly right. But you have to see it in context of
					learning.
				</p>
				<p>
					The main reason I offer free website for design/art/graphic is that i
					want to get experience in this field. An field where you push the
					boundaries of animations and ideas. Designing and building the website
					will take more time then your usual business website. And we all know:{" "}
					<code>time = money</code>
				</p>
				<p>
					Thats why i dont expect a payment. But a convenience in form of a
					favour or service is always welcome :)
				</p>
			</Section>
		</Layout>
	)
}

export default IndexPage
